import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import VueMobileDetection from 'vue-mobile-detection'
import Vue2Editor from 'vue2-editor'
import { firestorePlugin } from 'vuefire'
import { db, storage } from '@/firebase'

Vue.config.productionTip = false

Vue.use(VueMobileDetection)
Vue.use(Vue2Editor)
Vue.use(firestorePlugin)

Vue.prototype.$db = db
Vue.prototype.$storage = storage

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
